module.exports = __webpack_public_path__ + "img/6_fineStaff_fr.17ba98b5.png";